export function getFieldSettingValue(fieldSettings, fieldName) {
  if (!fieldSettings) return undefined;
  const hasOwnValue = Object.prototype.hasOwnProperty.call(fieldSettings, fieldName);

  if (fieldName === "barcode_number" && !hasOwnValue) {
    return fieldSettings.barcode;
  }

  if (fieldName === "photo" && !hasOwnValue) {
    return fieldSettings.photo ?? fieldSettings.photo_carousel ?? fieldSettings.photo_upload;
  }

  return fieldSettings[fieldName];
}

export function normalizeProjectFieldSettings(fieldSettings = {}) {
  const normalized = { ...fieldSettings };
  const barcodeNumber = getFieldSettingValue(fieldSettings, "barcode_number");
  const photo = getFieldSettingValue(fieldSettings, "photo");

  if (barcodeNumber !== undefined) {
    normalized.barcode_number = barcodeNumber;
  }

  if (photo !== undefined) {
    normalized.photo = photo;
  }

  delete normalized.barcode;
  delete normalized.photo_carousel;
  delete normalized.photo_upload;

  return normalized;
}

/**
 * Check whether a single field-setting value is "enabled".
 *
 * Field settings are stored in several legacy formats:
 *   - Boolean:  true / false
 *   - Numeric:  1 / 0
 *   - String:   "true" / "false"
 *   - Array:    ["on"]  (legacy checkbox format)
 *   - Object:   { visible: true, required: false }
 *
 * A missing / null / undefined value is treated as disabled.
 */
export function isFieldSettingEnabled(fieldSettingsOrValue, fieldName) {
  const value =
    typeof fieldName === "string"
      ? getFieldSettingValue(fieldSettingsOrValue, fieldName)
      : fieldSettingsOrValue;

  if (value === true || value === 1 || value === "true") return true;
  if (Array.isArray(value)) return value.includes("on");
  if (typeof value === "object" && value !== null) return value.visible === true;
  return false;
}
